import React from "react";
import { Spinner } from "react-bootstrap";
import TimePickerModal from "../time-picker";
import ActionButton from "./actionBtn";
import CloseButton from "./closeBtn";
import { useModalManager } from "../../hooks/useModalManager";
import { useMerchant } from "../../context/merchant";
import { PrepExtendButtons } from "../../components/orderProgress";

export default function OrderDetailsButtons({
  handleUpdateStatus,
  loading,
  isFullScreen,
  handleClose,
  statusId,
  orderId,
  // Бэлдэж байгаа, хараахан сунгаагүй (2026-09-17) — «+10 / +20 мин».
  extendable = false,
  onExtended,
}) {
  const { openModal, closeModal, currentModal } = useModalManager();

  const { duration: defaultDuration } = useMerchant();

  const handleConfirmPreparation = () => {
    // Сервер `prepStartedAt`/`prepDuration`-ыг бичдэг (updateOrderStatus 3), дараагийн
    // poll нь prepRemainingSec-ийг буцаана — localStorage бичих шаардлагагүй.
    handleUpdateStatus(3, parseInt(defaultDuration));
  };

  const renderButtons = () => {
    switch (statusId) {
      case 2:
        return (
          <>
            <ActionButton
              onClick={handleConfirmPreparation}
              disabled={loading}
              isFullScreen={isFullScreen}
            >
              {loading ? (
                <Spinner as="span" animation="border" size="sm" role="status" />
              ) : (
                `Бэлдэх (${defaultDuration / 60} минут)`
              )}
            </ActionButton>
            <div className="d-flex">
              <div className="col me-2">
                <ActionButton
                  variant="warning"
                  onClick={() => openModal("time-picker")}
                  disabled={loading}
                  isFullScreen={isFullScreen}
                >
                  Хугацаа сонгох
                </ActionButton>
              </div>
              <div className="col-6">
                <CloseButton
                  onClose={handleClose}
                  isFullScreen={isFullScreen}
                />
              </div>
            </div>
          </>
        );
      case 3:
        return (
          <>
          {/* Хоол бэлэн болоогүй — хугацааг нэг удаа сунгана. Хэрэглэгч ба жолоочид
              «ресторан хугацаа сунгалаа» гэж харагдана (2026-09-17). */}
          {extendable ? (
            <div className="mb-2">
              <div className="small text-muted mb-1">Хоол бэлэн болоогүй бол хугацаа сунгах (1 удаа):</div>
              <PrepExtendButtons orderId={orderId} large onDone={onExtended} />
            </div>
          ) : null}
          <div className="d-flex">
            {/* <div className="col me-2">
              <ActionButton
                variant="warning"
                onClick={() => {
                  handleUpdateStatus(4);
                  handleClose();
                }}
                disabled={loading}
                isFullScreen={isFullScreen}
              >
                Жолооч дуудах
              </ActionButton>
            </div> */}
            <div className="col">
              <CloseButton onClose={handleClose} isFullScreen={isFullScreen} />
            </div>
          </div>
          </>
        );
      case 4:
      default:
        return (
          <CloseButton onClose={handleClose} isFullScreen={isFullScreen} />
        );
    }
  };

  return (
    <div className="col">
      {renderButtons()}
      <TimePickerModal
        show={currentModal === "time-picker"}
        handleClose={closeModal}
        orderId={orderId}
        handleUpdateStatus={handleUpdateStatus}
        loading={loading}
      />
    </div>
  );
}
